const stringToArray = (val : string | Array<string>) => {
  if(typeof val === 'string') {
    return val.trim().split(',').filter((item) => item.trim() !== '');
  }
  return val;
}

export const transformations = {
  request_type: [],
  lists: [stringToArray],
  contact_lists: [stringToArray],
  suppression_lists: [stringToArray],
  rodId: [stringToArray],
  company_ids: [stringToArray],
  company_domains: [stringToArray],
  company_names: [stringToArray],
//   company_naics_codes: [stringToArray],
//   company_naics_codes_none: [stringToArray],
//   company_naics_codes_all: [stringToArray],
//   company_naics_codes_any: [stringToArray],
company_location_zipcodes: [stringToArray],
  contact_location_zipcodes: [stringToArray],
  company_technographic_products: [stringToArray],
  company_technographic_vendors: [stringToArray],
  company_min_size: [],
  company_max_size: [],
  company_location_zipcodes_distance: [],
  contact_location_zipcodes_distance: [],
  company_location_states: [stringToArray],
  contact_location_states: [stringToArray],
  company_location_metro: [stringToArray],
  contact_location_metro: [stringToArray],
  technographics: [],
  rankings: [],
  company_technographic_categories: [stringToArray],
  company_technographic_sub_categories: [stringToArray],
  company_technographic_sub_categories_any: [stringToArray],
  company_technographic_sub_categories_all: [stringToArray],
  company_technographic_sub_categories_none: [stringToArray],
  is_international: [],
  location_country_codes: [stringToArray],
  company_location_hq: [],
  company_location_branch: [],
  contact_revenue_max_identifier: [],
  contact_revenue_min_identifier: [],
  job_levels: [],
  job_departments: [],
  job_sub_departments: [stringToArray],
  required_fields: [],
  tiers: [],
  location_types: [stringToArray],
  gte_last_modified_date: [],
  matchOnJobHistory: [],
  page: [],
  verified : [],
  selected_boolean_operator: [],
  accuracy_tier_contact: [],
  accuracy_tier_company: [],
  specialties: [stringToArray],
  specialties_any: [stringToArray],
  specialties_all: [stringToArray],
  specialties_none: [stringToArray],
//   company_sic_codes: [stringToArray],
//   company_sic_codes_all: [stringToArray],
//   company_sic_codes_any: [stringToArray],
//   company_sic_codes_none: [stringToArray],
  company_technographic_products_bool: [],
  company_technographic_vendors_bool: [],
  company_technographic_sub_categories_bool: [],
  company_min_revenue: [],
  intent_minimum_score: [],
  intent_topic_threshold: [],
  first_name: [],
  last_name: [],
  email: [],
  intent_topic_ids: [stringToArray],
  si_intent_topic_ids: [stringToArray],
  job_title: [],
  job_title_all: [],
  job_title_any: [],
  job_title_none: [],
  company_max_revenue: [],
};
